import { isValidPhoneNumber } from 'libphonenumber-js';
import * as yup from 'yup';

import { COMMON_MAIL_DOMAINS } from './mainDomains';

// URL regex: protocol optional, valid domain required, and path (optional)
const URL_REGEXP =
  /^(?:https?:\/\/|ftp:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
// Strict email regex: requires a TLD (e.g. user@domain.com), unlike yup's
// built-in .email() which allows emails without a TLD (e.g. user@domain)
const STRICT_EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const IS_VALID_PHONE = 'phone';
export const IS_VALID_URL = 'customUrl';
export const IS_STRICT_EMAIL = 'strictEmail';
export const checkIsEmailCommon = (email: string) =>
  COMMON_MAIL_DOMAINS.some((domain) => email.includes(domain));

export const setupCustomValidators = () => {
  yup.addMethod(yup.string, 'onlyBusinessEmail', function () {
    return (this as any).test({
      name: 'onlyBusinessEmail',
      message: 'Please enter a valid business e-mail address.',
      test: (value: string | undefined = '') => {
        const [, currentDomain = ''] = value.split('@') || [];
        const res = !COMMON_MAIL_DOMAINS.some(
          (domain) => currentDomain === domain,
        );

        return res;
      },
    });
  });

  yup.addMethod(yup.string, IS_VALID_PHONE, function () {
    return (this as any).test({
      name: IS_VALID_PHONE,
      message: 'Invalid phone',
      test: (phone = '') => {
        const sanitizedPhone = phone.replace('+', '');

        return !sanitizedPhone || isValidPhoneNumber(phone);
      },
    });
  });

  yup.addMethod(yup.string, IS_VALID_URL, function (message?: string) {
    return (this as any).test({
      name: IS_VALID_URL,
      message: message || 'Invalid url',
      test: (url = '') => {
        return !url || URL_REGEXP.test(url);
      },
    });
  });

  yup.addMethod(yup.string, IS_STRICT_EMAIL, function (message?: string) {
    return (this as any).test({
      name: IS_STRICT_EMAIL,
      message: message || 'Invalid email',
      test: (email = '') => {
        return !email || STRICT_EMAIL_REGEXP.test(email);
      },
    });
  });
};
